export function afterChangeDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: afterChangeDirectiveCtrl,
	};
}

export class afterChangeDirectiveCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		$element.on('change', () => {
			$scope.$eval($attrs.shAfterChange);
		});
	}
}
